import * as React from 'react';
import '../Project.css';
import ProjectInterestedCardContainer from './ProjectInterestedCard.container';
import Person from 'src/entities/Person';
import Project from 'src/entities/Project';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';

interface Props {
  projectInterested: Person[];
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

class ProjectInterestedComponent extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <div className="col-sm-9">
        <div className="padding-left-30">
          <div className="gap-50"/>

          <h3>
            Interesados
          </h3>
          <div className="gap-20"/>
          <div className="row padding-l-r-30">
            {this.props.projectInterested.map((interestedUser, key) => (
              <ProjectInterestedCardContainer
                key={key}
                interestedUser={interestedUser}
              />
            ))}
          </div>
          <div className="gap-50"/>
          <ProjectActionToolbarContainer
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.props.closedProject}
          />
          <div className="gap-50"/>
        </div>
      </div>
    );
  }
}

export default ProjectInterestedComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-interested/ProjectInterested.component.tsx